import { render, staticRenderFns } from "./BankDeposit.vue?vue&type=template&id=3e636ea4"
import script from "./BankDeposit.vue?vue&type=script&lang=js"
export * from "./BankDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports